import { Col, Row } from 'antd'
import LeftArrow from 'components/icons/LeftArrow'
import React from 'react'
import CloseIcon from '../../../components/icons/CloseIcon'
import {
  ArrowTitle,
  IconAlign,
  TextWithIcon,
  TitleHeaderSection,
} from '../style'
import InformationHeader from './Components/InformationHeader'
export default function PreviewHeader({
  previewData,
  getExportFiledData,
  exportCandidate,
  instituteCampusId,
  handleBack,
  handleNavigate,
  status,
  isLoading,
  categorayFilter,
  downlaodData,
  getOneRoleExports,
  onHandleClose,
  completeRole,
  onHandleComplete,
  singleRoleData
}) {
  return (
    <>
      <TitleHeaderSection>
        <Row justify="space-between">
          <Col md={12} xs={12}>
            <TextWithIcon>
              <IconAlign onClick={handleBack} style={{ cursor: 'pointer' }}>
                <LeftArrow />
              </IconAlign>
              <ArrowTitle>Role</ArrowTitle>
            </TextWithIcon>
          </Col>
          <Col>
            <TextWithIcon justify={'end'} onClick={handleBack}>
              <CloseIcon style={{ cursor: 'pointer' }} />
            </TextWithIcon>
          </Col>
        </Row>
      </TitleHeaderSection>
      <InformationHeader
        instituteCampusId={instituteCampusId}
        getExportFiledData={getExportFiledData}
        exportCandidate={exportCandidate}
        previewData={previewData}
        handleNavigate={handleNavigate}
        status={status}
        isLoading={isLoading}
        categorayFilter={categorayFilter}
        downlaodData={downlaodData}
        getOneRoleExports={getOneRoleExports}
        onHandleClose={onHandleClose}
        completeRole={completeRole}
        onHandleComplete={onHandleComplete}
        singleRoleData={singleRoleData}
      />
    </>
  )
}
